import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Contact.css";
import call_ic from "../Images/ic-call.png";
import email_ic from "../Images/ic-email.png";
import location_ic from "../Images/ic-locations.png";
import ic_bg from "../Images/ic-bg.png";
import { BASE_URL, CONTACT_ADD } from "../Api/apiConstant";
import { Form, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useThemeColors } from "../Context/Theme";
import {
  validateEmail,
  validateName,
  validatePhone,
} from "../Utils/Validation";
import { PRIMARY } from "../styles/color";
import GlobalInput from "../components/CustomInput";
import { formatPhoneNumber } from "../global/helpers";
import orderThatWhiteIcon from "../Images/orderThatIconWhite.png";
import { getToken } from "../LoginModule/LoginUtility";
import API_URL from "../ServiceModule/Service";

const Contact = () => {
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    buttonTextColor,
    backgroundColor,
    logo,
    fontFamily,
    fontWeight,
    fontSize,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading,
  } = useThemeColors();

  const eventName = sessionStorage.getItem("eventName");

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    message: "",
  });

  const labelStyles = {
    fontFamily: fontFamilyHeading,
    fontSize: fontSizeHeading,
    fontWeight: fontWeightHeading
  };

  const [error, setError] = useState({
    fullName: false,
    email: false,
    phone: false,
    message: false,
  });

  const [emailError, setEmailError] = useState("");
  const [validPhone, setValidPhone] = useState(true);
  const [loading, setLoading] = useState(false);
  const eventId = sessionStorage.getItem("event_id");
  const token = getToken();
  const location = useLocation();

  const isAtAllEvents = sessionStorage.getItem('isAtAllEvents') === 'true' ? true : false;

  const validatePhoneInput = (e) => {
    let input = e.target.value;
    let numericInput = input.replace(/\D/g, "");

    if (numericInput.startsWith("0")) {
      setValidPhone(false);
      return;
    }

    if (numericInput.length > 10) {
      numericInput = numericInput.slice(0, 10);
    }

    setFormData({ ...formData, phone: numericInput });
    setValidPhone(numericInput.length === 10 && validatePhone(numericInput));
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "email") {
      if (!validateEmail(value)) {
        setEmailError("Please enter a valid email address");
      } else {
        setEmailError("");
      }
    }
  };

  const handleSubmit = async (e) => {
    if(loading) return;
    e.preventDefault();
    setLoading(true);
    const trimmedData = {
      fullName: formData.fullName.trim(),
      email: formData.email.trim(),
      phone: formData.phone.trim(),
      message: formData.message.trim(),
    };

    const errors = {
      fullName: !validateName(trimmedData.fullName),
      email: !validateEmail(trimmedData.email),
      phone: !validatePhone(trimmedData.phone),
      message: trimmedData.message.length === 0,
    };

    setError(errors);

    if (Object.values(errors).some(Boolean)) {
      toast.error("Please fill all the required fields.");
      return;
    }

    try {
      const data = new FormData();
      data.append("event_id", eventId ? eventId : 0);
      data.append("first_name", trimmedData.fullName);
      data.append("email", trimmedData.email);
      data.append("phone_number", trimmedData.phone);
      data.append("message", trimmedData.message);

      const response = await fetch(API_URL + CONTACT_ADD, {
        method: "POST",
        body: data,
      });
      if (!response.ok) {
        const errorResponse = await response.text();
        throw new Error(`Network error: ${errorResponse}`);
      }
      setFormData({ fullName: "", email: "", phone: "", message: "" });
      toast.success("Message sent successfully!");
      setLoading(false)
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Error sending message. Please try again.");
    }
  };

  return (
    <>
      <ToastContainer style={{ zIndex: 9999999999 }} autoClose={2000} />
      <Navbar isAtAllEvents={eventName == "contact" ? true : isAtAllEvents} className="sticky-navbar" />
      <div
        className="contact-container"
        style={{ backgroundColor: backgroundColor, marginTop: "10vh" }}
      >
        <h2 className="contact-title" style={{
          color: textColor || PRIMARY,
          fontFamily: fontFamilyHeading,
          fontSize: fontSizeHeading,
          fontWeight: fontWeightHeading
        }}>
          Contact Us
        </h2>
        <p className="contact-subtitle" style={{
          fontFamily,
          fontSize,
          fontWeight
        }}>
          Any questions or remarks? Just send us a message!
        </p>
        <div className="contact-wrapper">
          <div className="contact-content">
            <div className="contact-info">
              <h3 style={{
                fontFamily: fontFamilyHeading,
                fontSize: fontSizeHeading,
                fontWeight: fontWeightHeading
              }}>Contact Information</h3>
              <p style={{
                fontFamily,
                fontSize,
                fontWeight
              }}>Say something to start a conversation!</p>
              <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                <li style={{ display: "flex", alignItems: "center", fontSize: fontSize || "14px", marginBottom: "30px" }}>
                  <img style={{ width: "24px", height: "24px", marginRight: "15px" }} src={call_ic} alt="Call Icon" />
                  <a href="tel:+10123456789" style={{ color: "white", textDecoration: "none", fontSize: fontSize || "14px", lineHeight: "1.5", fontWeight, fontFamily }}>
                    +1012 3456 789
                  </a>
                </li>
                <li style={{ display: "flex", alignItems: "center", fontSize: fontSize || "14px", marginBottom: "30px" }}>
                  <img style={{ width: "24px", height: "24px", marginRight: "15px" }} src={email_ic} alt="Email Icon" />
                  <a href="mailto:contact@orderthat.com" style={{ color: "white", textDecoration: "none", fontSize: fontSize || "14px", fontWeight, fontFamily, lineHeight: "1.5" }}>
                    contact@orderthat.com
                  </a>
                </li>
                <li style={{ display: "flex", alignItems: "center", fontSize: fontSize || "14px" }}>
                  <img style={{ width: "24px", height: "24px", marginRight: "15px" }} src={location_ic} alt="Location Icon" />
                  <span style={{ fontSize: fontSize || "14px", fontWeight, fontFamily, lineHeight: "1.5", color: "white" }}>
                    132 Dartmouth Street Boston, Massachusetts 02156 United States
                  </span>
                </li>
              </ul>
              <div className="">
                <img src={ic_bg} alt="Background Icon" className="" style={{ width: "60%", marginLeft: "11em", marginBottom: "-3em" }} />
              </div>
            </div>
            <form className="contact-form">
              <div className="form-group">
                <div className="form-field">
                  <GlobalInput
                    label="Full Name"
                    value={formData.fullName}
                    onChange={handleChange}
                    name="fullName"
                    placeholder="Enter your full name"
                    className={error.fullName}
                    required
                    onBlur={() => setError({ ...error, fullName: !validateName(formData.fullName) })}
                    style={{ borderColor: error.fullName ? "red" : "" }}
                  />
                  {error.fullName && (
                    <div className="error-text mt-2" style={{ fontFamily, fontSize, fontWeight }}>
                      Please enter a valid full name
                    </div>
                  )}
                </div>
              </div>
              <div className="form-group">
                <div className="form-field">
                  <GlobalInput
                    label="Email"
                    value={formData.email}
                    onChange={handleChange}
                    name="email"
                    placeholder="Enter your email"
                    className={error.email}
                    required
                    onBlur={() => setError({ ...error, email: !validateEmail(formData.email) })}
                    style={{ borderColor: error.email ? "red" : "" }}
                  />
                  {error.email && (
                    <div className="error-text mt-2" style={{ fontFamily, fontSize, fontWeight }}>
                      Please enter a valid email address
                    </div>
                  )}
                </div>
                <div className="form-field">
                  <GlobalInput
                    label="Phone Number"
                    value={formData.phone ? formatPhoneNumber(formData.phone) : ""}
                    onChange={validatePhoneInput}
                    placeholder="Enter Phone number"
                    className={error.phone}
                    minLength={12}
                    maxLength={12}
                    required
                    onBlur={() => setError({ ...error, phone: !validatePhone(formData.phone) })}
                    style={{ borderColor: error.phone ? "red" : "" }}
                  />
                  {error.phone && (
                    <p className="error-text mt-2" style={{ fontFamily, fontSize, fontWeight }}>
                      Please enter a valid phone number
                    </p>
                  )}
                </div>
              </div>
              <div className="">
                <label style={labelStyles}>Messages<span
                  style={{
                    color: "red",

                  }}>*</span></label>
                <textarea
                  name="message"
                  value={formData.message}
                  className="form-control form-control-lg mt-3"
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const wordCount = inputValue.split(/\s+/).filter(Boolean).length;
                    if (wordCount <= 250) {
                      setFormData({ ...formData, message: inputValue });
                      setError({ ...error, message: false });
                    }
                  }}
                  onBlur={() => setError({ ...error, message: !validateName(formData.message) })}
                  style={{
                    border: error.message ? "1px solid red" : "",
                    borderRadius: "10px",
                    fontFamily,
                    fontSize,
                    fontWeight,
                  }}
                  placeholder="Write your message..."
                />
                <style>
                  {`
                      textarea::placeholder {
                        font-size: ${fontSize || "3em"},
                        font-weight: ${fontWeight || "500"},
                        font-family: ${fontFamily}
                      }
                    `}
                </style>

                {error.message && (
                  <div className="error-text mt-2" style={{ fontFamily, fontSize, fontWeight }}>
                    Please enter a valid message
                  </div>
                )}
              </div>
              <button disabled={loading}  onClick={handleSubmit} type="submit" className="send-message-btn" style={{
                fontFamily,
                fontSize,
                fontWeight
              }}>
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer isAtAllEvents={isAtAllEvents} icon={orderThatWhiteIcon} />
    </>
  );
};

export default Contact;
